import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';

@Component({
  selector: 'app-club-questions',
  templateUrl: './club-questions.component.html',
  styleUrls: ['./club-questions.component.sass']
})
export class ClubQuestionsComponent implements OnInit {
  public tabActive='Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  public content:object;
  constructor(public global:GlobalService) { }

  ngOnInit() {
    this.content={
      content:[
        {
          title:"¿Cómo funciona el programa?",
          description:"Descargar gratis el app de BUREA en tu tienda de aplicaciones Android o IOS.<br><br>Validar número de teléfono que posea con servicio Claro (móvil o residencia).<br><br>Acceso a ofertas exclusivas solo para clientes con algún servicio de Claro.<br><br>Las ofertas excusivas estarán identificadas con el ícono que dice “Claro Club”.",
          expand:true
        },
        {
          title:"¿Quién cualifica en el programa?",
          description:"Todo cliente activo que posea algún servicio de Claro (móvil o residencial).",
          expand:false
        },
        {
          title:"¿Cómo se acumula en cash back?",
          description:"Redime la oferta que usaste, subiendo una foto del recibo de la compra.<br><br> En 72 horas o menos Burea validara el recibo de compra y luego acredita el CASHBACK establecido en la oferta.",
          expand:false
        },
        {
          title:"¿Cómo se obtiene el cash back y utiliza?",
          description:"Al obtener o acumula un mínimo de $20 el cliente puede transferir el mismo a su cuenta bancaría, cuenta de cooperativa o cuenta de PayPal.<br><br>Una vez el cliente posea el dinero del cash back en su cuenta pueda hacer uso del mismo como desee.",
          expand:false
        }
      ]
    };
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
}
